export const handleDecrementTimer = ({ prevState }) => {
  const { verificationCodeTimer } = prevState;
  return verificationCodeTimer > 1
    ? {
        ...prevState,
        verificationCodeTimer: verificationCodeTimer - 1,
      }
    : {
        ...prevState,
        verificationCodeTimer: 0,
        isTimerStarted: false,
      };
};
